<div class="input-pill-wrapper">
  <div class="input-pill-disabled-overlay" *ngIf="disabled"></div>
  <div class="input-pill-options-container">
    <label class="app-label"  *ngIf="translationLabel || label"
      >{{ translationLabel || label | translation }}
    </label>
    <i
      style="padding-left: 5px"
      tooltipPosition="top"
      pTooltip="{{ tooltip }}"
      *ngIf="tooltip"
      class="fa-solid fa-circle-question text-link-color"
    ></i>
    <div class="input-pill-input-container">
      <p-inputgroup>
        <input (focus)="onFocus()" [formControl]="newInput" #internalInput style="padding-right: 75px" pInputText
          fluid [placeholder]="placeholder" (keyup.enter)="addInput()" />
        <p-inputgroup-addon>
          <button class="input-pill-input-enter-btn" [disabled]="shouldDisable" pButton severity="primary"
            (click)="addInput()">
            Enter
          </button>
        </p-inputgroup-addon>
      </p-inputgroup>
      <div
        *ngIf="filteredOptions.length"
        class="input-pill-autocomplete-suggestions"
      >
        <div
          class="input-pill-autocomplete-suggestion"
          *ngFor="let option of filteredOptions"
          (click)="selectOption(option)"
          tabindex="0"
          (keydown.enter)="selectOption(option)"
        >
          {{ option }}
        </div>
      </div>
    </div>

    <div class="input-pill-input">
      <div *ngFor="let control of controlValue; let i = index" style="display: inline-block; margin-right: 5px;">
        <p-chip label="{{ control?.value || control || '' }}" [removable]="true" (onRemove)="removeElement(i)"></p-chip>
      </div>
    </div>
  </div>
</div>
